__turbopack_context__.v({
  "bar": "cart-view-module-scss-module__ix7B0W__bar",
  "bar-total": "cart-view-module-scss-module__ix7B0W__bar-total",
  "count": "cart-view-module-scss-module__ix7B0W__count",
  "empty": "cart-view-module-scss-module__ix7B0W__empty",
  "empty-cta": "cart-view-module-scss-module__ix7B0W__empty-cta",
  "empty-text": "cart-view-module-scss-module__ix7B0W__empty-text",
  "empty-title": "cart-view-module-scss-module__ix7B0W__empty-title",
  "heading": "cart-view-module-scss-module__ix7B0W__heading",
  "layout": "cart-view-module-scss-module__ix7B0W__layout",
  "list": "cart-view-module-scss-module__ix7B0W__list",
  "main": "cart-view-module-scss-module__ix7B0W__main",
  "recs": "cart-view-module-scss-module__ix7B0W__recs",
  "root": "cart-view-module-scss-module__ix7B0W__root",
  "rows": "cart-view-module-scss-module__ix7B0W__rows",
  "title": "cart-view-module-scss-module__ix7B0W__title",
  "toast": "cart-view-module-scss-module__ix7B0W__toast",
  "toast-body": "cart-view-module-scss-module__ix7B0W__toast-body",
  "toast-icon": "cart-view-module-scss-module__ix7B0W__toast-icon",
});
